"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function toggleFavoriteAction() {
    return {
        type: 'V16/favorite_button/toggle',
    };
}
exports.toggleFavoriteAction = toggleFavoriteAction;
function setMotivationPopupVisibleAction(isVisible) {
    return {
        isVisible: isVisible,
        type: 'V16/favorite_button/set-motivation-popup-visible',
    };
}
exports.setMotivationPopupVisibleAction = setMotivationPopupVisibleAction;
exports.defaultFavoriteButtonState = {
    isActive: false,
    motivationIsVisible: false,
};
function favoriteButtonReducer(state, action) {
    if (state === void 0) { state = exports.defaultFavoriteButtonState; }
    switch (action.type) {
        case 'V16/favorite_button/toggle':
            return tslib_1.__assign({}, state, { isActive: !state.isActive });
        case 'V16/favorite_button/set-motivation-popup-visible':
            return tslib_1.__assign({}, state, { motivationIsVisible: action.isVisible });
        default:
            return state;
    }
}
exports.favoriteButtonReducer = favoriteButtonReducer;



//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/state.ts
// module id = 117
// module chunks = 2